module.exports = __webpack_public_path__ + "static/media/home-feeling-better2.2a26c494.svg";